import httpClientPayments from '../api/httpClientPayments';

const buildScopeParams = ({
  memberId,
  includeSpouse = true,
  includeEventGuests = true,
  includeMealGuests = true,
}) => ({
  memberId,
  includeSpouse,
  includeEventGuests,
  includeMealGuests,
});

export const getMemberAccountSummary = async ({
  memberId,
  includeSpouse = true,
  includeEventGuests = true,
  includeMealGuests = true,
} = {}) => {
  const response = await httpClientPayments.get('/api/payments/MemberAccount/Summary', {
    params: buildScopeParams({ memberId, includeSpouse, includeEventGuests, includeMealGuests }),
  });
  return response.data;
};

export const getMemberAccountLedger = async ({
  memberId,
  includeSpouse = true,
  includeEventGuests = true,
  includeMealGuests = true,
  ledgerKind = 0,
  sourceTypes = null,
  subjectType = null,
  status = null,
  period = null,
  startDate = null,
  endDate = null,
  pageNumber = 1,
  pageSize = 20,
} = {}) => {
  const params = {
    ...buildScopeParams({ memberId, includeSpouse, includeEventGuests, includeMealGuests }),
    ledgerKind,
    pageNumber,
    pageSize,
  };

  if (sourceTypes != null && sourceTypes.length > 0) {
    params.sourceTypes = sourceTypes.join(',');
  }
  if (subjectType != null && subjectType !== '') params.subjectType = subjectType;
  if (status) params.status = status;
  if (period) params.period = period;
  if (startDate) params.startDate = startDate;
  if (endDate) params.endDate = endDate;

  const response = await httpClientPayments.get('/api/payments/MemberAccount/Ledger', { params });
  return response.data;
};

export default {
  getMemberAccountSummary,
  getMemberAccountLedger,
};
